import { render, staticRenderFns } from "./MyKidsWidget.vue?vue&type=template&id=62013028&scoped=true&"
import script from "./MyKidsWidget.vue?vue&type=script&lang=js&"
export * from "./MyKidsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62013028",
  null
  
)

export default component.exports